export type TabId =
  | 'community'
  | 'gravity'
  | 'ministries'
  | 'connect'
  | 'volunteer'
  | 'login';

export interface TabConfig {
  id: TabId;
  label: string;
  hash: string;
  index: number;
}

export const TABS: TabConfig[] = [
  { id: 'community', label: 'Community', hash: '#community', index: 0 },
  { id: 'gravity',   label: 'GRAVITY YOUTH',   hash: '#gravity',   index: 1 },
//   { id: 'ministries',label: 'Ministries',hash: '#ministries', index: 2 },
//   { id: 'volunteer', label: 'Volunteer', hash: '#volunteer',  index: 3 },
  { id: 'connect',   label: 'Connect',   hash: '#connect',   index: 4 },
  { id: 'login',     label: 'Login',     hash: '#login',      index: 5 },
];

export function tabFromHash(hash: string): TabConfig {
  return TABS.find((t) => t.hash === hash) ?? TABS[0];
}
